import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import {
  Redirect,
} from 'react-router-dom'
import IconAccount from '@material-ui/icons/AccountBox';

// import { Link } from 'react-router-dom';


// if redux-form-material-ui
// import { reduxForm, Field } from 'redux-form';
// import { TextField } from 'redux-form-material-ui'
import TextField  from '@material-ui/core/TextField'

import {
  login as initiateLogin,
  hasLoginFailed,
  getError as getAuthenticationError,
  getCurrentUserRole,
  isLoggingIn,
  isLoggedIn,
} from 'ducks/authentication';

import Paper from '@material-ui/core/Paper';
// import RaisedButton from '@material-ui/core/RaisedButton';
import RaisedButton from '@material-ui/core/Button';
// import debounce from 'mout/function/debounce';

// import styles from './LoginPage.cssmodule.scss';

const ValidateRequired = ($$field, value) => value === null ? $$field.get('label')+' Requis' : undefined
const ValidateEmail = ($$field, value) => (value &&
!/^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\s*$/i.test(value)) || value === undefined || value === '' ? 'Identifiant invalide' : undefined


const FIELDS = {
  'email': {
    'validation': ['email'],
    'label': 'Identifiant'
  },
  'password': {
    'validation': ['required'],
    'label': 'Mot de Passe'
  }
}
const $$FIELDS = Immutable.fromJS(FIELDS);

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  _setFieldValue(e) {
    let h = {}
    h[e.target.id] = e.target.value;
    this.setState(h)
  }

  _validateFieldsInput() {
    let log = [], check;
    $$FIELDS.map((field, fieldName) => {
      const value = this.state[fieldName];
      field.get('validation').map(validation => {
        switch(validation) {
          case 'email':
            check = ValidateEmail(field, value);
            if (check !== undefined) log.push(check);
          break;
          default:
          case 'required':
            check = ValidateRequired(field, value);
            if (check !== undefined) log.push(check);
          break;
        }
        return true;
      })
      return true;
    })
    return log.length === 0 ? true : log;
  }
  _handleSubmit(e) {
    e.stopPropagation()
    e.preventDefault();
    const { loading } = this.props;

    if (loading) {
      console.log('already loading!');
      return ;
    }
    const log = this._validateFieldsInput()
    if (log === true) {
      this.props.onSubmit({email: this.state.email, password: this.state.password});
    } else {
      this.setState({log: log})
    }
  }
  render() {
    const {
      // hasLoginFailed,
      error,
      loading,
      isLoggedIn,
      userRole,
    } = this.props;
    //
    const mdStyle = {
      paperHead: {
        margin: 'inherit',
        textAlign: 'center',
        display: 'block',
        padding: 20,
        backgroundColor: '#998778'
      },
      paper: {
        margin: '30px auto',
        textAlign: 'center',
        display: 'block',
        padding: 20,
        backgroundColor: 'transparent'
      },
      divider: {
        width: '10%'
      },
      button: {
        marginTop: 20
      }
    };

    const { log } = this.state;

    if (isLoggedIn) {
      const url = userRole === 'entreprise' ? '/mission' : '/profil'
      return <Redirect to={{
          pathname: url,
          state: { from: this.props.location }
        }}/>
      }
      return (
        <div className='Login'>
          <div className="wrapper">
            <div className="content">
                <Paper style={{...mdStyle.paperHead, margin: '10px 0'}} className="instructions">
                <IconAccount style={{width: 34, height: 34, display: 'inline-block', marginTop: -5, marginBottom: 0, marginRight: 5, verticalAlign: 'middle'}}/>Connectez-vous
              </Paper>
              <div className="form">
                <Paper style={{...mdStyle.paper, margin: '10px 0'}}>
                  <form onSubmit={this._handleSubmit.bind(this)}>
                    <span className={'row'}><TextField name="email" id="email"
                      label="Identifiant"
                    onChange={this._setFieldValue.bind(this)} autoComplete={'username'} style={{width: 280}}/></span>
                  <span className={'row'}><TextField name="password" id="password"
                      type="password"
                      label="Mot de passe"
                      onChange={this._setFieldValue.bind(this)} autoComplete={'current-password'} style={{width: 280}}/></span>

                    <span className={'row'}><RaisedButton style={mdStyle.button} disabled={loading} onClick={this._handleSubmit.bind(this)}>{loading ? "Connexion..." : "Connexion"}</RaisedButton></span>
                  </form>
                  <If condition={log !== undefined}>
                    <p className="error">{log}</p>
                  </If>
                  <If condition={error !== undefined}>
                    <p className="error">{error}</p>
                  </If>
                </Paper>
              </div>
            </div>
          </div>
      </div>
    );

  }
}

const mapStateToProps = ($$state) => {
  return {
    hasLoginFailed: hasLoginFailed($$state),
    error: getAuthenticationError($$state),
    loading: isLoggingIn($$state),
    isLoggedIn: isLoggedIn($$state),
    userRole: getCurrentUserRole($$state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (values) => {
      // console.log(values);
      const login = values.email;
      const password = values.password;
      // console.log('login', login, 'password', password)
      dispatch(initiateLogin(login, password));
    },
  };
};

// if redux-form-material-ui
// Login = reduxForm({
//   form: 'loginForm'
// })(Login)
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.jsx